import { Injectable } from '@angular/core';
import { AnalyticsApiService, QueryMetricsRequest, QueryMetricsResponse } from './_internal';
import { Observable } from 'rxjs';

@Injectable()
export class MultiLocationAnalyticsService {
  constructor(private api: AnalyticsApiService) {}

  queryMetrics(request: QueryMetricsRequest): Observable<QueryMetricsResponse> {
    return this.api.queryMetrics(request);
  }
}
